import script from "./SelectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__